<template>
  <div class="wg-row">
    <div class="wg-row" style="flex-wrap:nowrap;">
      <div class="wg-row">
        <div class="wg-row msg-row location">
          <!-- Luogo  -->
          <div class="com-anm22-app-text-m">
            {{ msg.data.location }}
          </div>
        </div>
        <div class="wg-row msg-row participants">
          <!-- Partecipanti  -->
          <div class="com-anm22-app-text-m">
            <img :src="$anm22.icons.getWorldIcon('group')" class="header-ic" :title="$anm22.strLang(lang, 'Participants', 'Partecipanti')" />
            {{ msg.data.participants }}
          </div>
        </div>
      </div>
      <div class="display-flex" style="margin-left:auto;flex-direction:column;">
        <div class="hour">
          {{ msg.ts | moment('HH:mm') }}
        </div>
        <div class="time" style="opacity:0.5;white-space:nowrap;">
          {{ duration }}
        </div>
      </div>
    </div>
    <div class="wg-row msg-row description">
      <div v-html="$anm22.nl2br(msg.data.description)" class="com-anm22-app-text-m"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    msg: Object
  },
  computed: {
    ...mapState({
      lang: state => state.lang
    }),
    duration() {
      const moment = this.$moment.utc(this.$moment.duration(this.msg.data.duration, 'seconds').asMilliseconds());
      const format = [ 
        moment.hours() !== 0 ? 'H [h]' : '',
        moment.minutes() !== 0 ? 'm [min]' : '',
        moment.seconds() !== 0 ? 's [s]' : ''
      ].join(' ');
      return moment.format(format);
    }
  }
}
</script>

<style lang="scss" scoped>
.msg-row {
  flex-wrap: nowrap;
  align-items: center;
}
.location, .participants {
  padding-top: 3px;
}
.header-ic {
  display: inline-block;
  opacity: 0.7;
  height: 20px;
  width: 20px;
  margin: 0;
  padding: 1px;
}
.hour {
  padding: 4px 5px 0 0;
  font-size: 12px;
  margin-left: auto;
}
.time {
  padding: 3px 5px 0 0;
  font-size: 12px;
  margin-left: auto;
  opacity:0.5;
  white-space:nowrap;
}
.description {
  margin-top: 6px;
}
</style>
